import config from 'app/config'
import { createUserQuery, userQueryToUser } from 'app/queries/user/cms-user'
import { UserSnapshot } from 'app/store/user'

type FetchCmsUserOptions = {
  cmsUrl?: string
  externalId?: string
  timeoutMs?: number
}

export async function fetchCmsUser(
  accessToken: string,
  options: FetchCmsUserOptions = {}
): Promise<UserSnapshot> {
  const { cmsUrl = config.cmsUrl, externalId, timeoutMs = config.timeout } =
    options

  const abortController = new AbortController()
  const timeout = setTimeout(() => {
    abortController.abort()
  }, timeoutMs)

  try {
    const cmsResponse = await fetch(cmsUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify({ query: createUserQuery() }),
      signal: abortController.signal,
    })

    if (!cmsResponse.ok) {
      const errorText = await cmsResponse.text()
      throw new Error(
        `CMS user fetch failed: ${cmsResponse.status} ${errorText}`
      )
    }

    const cmsData = await cmsResponse.json()
    if (!cmsData?.data) {
      throw new Error('CMS user fetch returned no data')
    }

    const user = userQueryToUser(cmsData.data)

    if (externalId) {
      user.externalId = externalId
    }

    return user
  } finally {
    clearTimeout(timeout)
  }
}
